import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Table, TableContainer, TableHead, Paper, Grid } from '@material-ui/core'
import { loadDepartures } from "../../store/dcs";
import { Results } from './results'
import { RowHeaders } from "./RowHeaders";
import _ from 'lodash';
import styles from "./styles";
import modalStyles from "./modals/styles"
import Headers from './headers/Headers';
import { fetchNewTexts, setAirline } from '../../store/dcs';
import { formatFlightDate } from './util/formatFlightDate';

export default function Dcs(props) {
  const dispatch = useDispatch();
  const {isMobile, theme, airline} = props;
  const classes = styles(theme, isMobile);
  const modalClasses = modalStyles(theme, isMobile);
  const loading = useSelector(state => state.entities.dcs.loading);
  const depDate = useSelector(state => state.entities.dcs.departureDate);
  const newTexts = useSelector(state => state.entities.dcs.newTexts);
  const filteredDeps = useSelector(state => state.entities.dcs.filteredDeps);

  useEffect(() => {
    dispatch(setAirline(airline))
    dispatch(loadDepartures(formatFlightDate(depDate)))
  }, [depDate]);

  useEffect(() => {
    dispatch(fetchNewTexts())
  }, [])

  // TODO // standby-indicator (var _standBy = paxList.match(/\- (SA|MM|PN)/g);)
  return (
    <div>
      {/* <Headers isMobile={isMobile} theme={theme} /> */}
      <Paper className={classes.root}>
        { !loading ?
          <div>
            <TableContainer >
              <Table aria-label="collapsible table">
                <TableHead className={classes.header}>
                  <RowHeaders isMobile={isMobile} />
                </TableHead>
                <Results filteredDeps={filteredDeps} date={depDate} newTexts={newTexts} modalClasses={modalClasses} isMobile={isMobile} />
              </Table>
            </TableContainer>
          </div> :
          <Grid container justify="center" item xs={12}>
            {/* TODO // make this look better */}
            <h3>Loading...</h3>
          </Grid>
        }
      </Paper>
    </div>
  );
}